import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Styles
import "./styles.scss";

// Redux
import { useDispatch } from "react-redux";
import { getAssessmentDetailsRequest_ADMIN } from "../../../../Redux/Slices/Admin/adminSlice";

// Custom layout
import MainLayout from "Layouts/Main";

// Assets
import Colors from "../../../../Assets/SassConstants/colors.scss";
import Back from "../../../../Assets/Svg/Admin/AssessmentBacklog/backChevron.svg";

const ViewAssessmentBacklog = () => {
  //Initialize redux
  const dispatch = useDispatch();

  // Initialize useNavigate
  const navigate = useNavigate();
  const location = useLocation();
  const { selectedAssessmentId } = location.state || {};

  //local states
  const [assessmentDetails, setAssessmentDetails] = useState({});

  useEffect(() => {
    dispatch(
      getAssessmentDetailsRequest_ADMIN({
        assessmentId: selectedAssessmentId,
        callBack: getAssessmentDetailsRequestCB_ADMIN,
      })
    );
  }, []);

  //To handle the response of getAssessmentDetailsRequest_ADMIN
  const getAssessmentDetailsRequestCB_ADMIN = (data) => {
    setAssessmentDetails(data);
  };

  return (
    <MainLayout style={{ backgroundColor: Colors.grey_12 }}>
      <div className="backlog-form-assessment-page">
        <div
          onClick={() => {
            navigate(-1);
          }}
          className="backlog-form-back-option"
        >
          <img src={Back} alt="Back" />
          <span className="backlog-form-back-text">
            Back to Assessment Backlog
          </span>
        </div>

        <div className="add-user-assessment-container">
          <div className="add-user-assessment-title">Company Details</div>
          <hr style={{backgroundColor:"grey"}} className="add-user-divider" />
          {/* company details */}
          <div className="assessment-backlog-details-card">
            <div className="assessment-backlog-details-card-header">
              <div className="assessment-backlog-details-staff-name-container">
                Assessment Details
              </div>
            </div>

            <div className="assessment-backlog-details-card-body">
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Account Name
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.company_name}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Country
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.country_name}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Industry
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.industry_name}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Assessment Name
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.assessment_name}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Reference  Number
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.reference_name}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Key Contact Name
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.keycontact_name}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Email Address
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.email}
                </div>
              </div>
              <div className="assessment-backlog-details-card-body-row">
                <div className="assessment-backlog-details-card-body-row-key">
                  Assigned Assessor
                </div>
                <div className="assessment-backlog-details-card-body-row-value">
                  : {assessmentDetails?.assessor_name}
                </div>
              </div>
            </div>
          </div>

          {/* user details */}
          {assessmentDetails?.users?.length > 0 && (
            <div className="assessment-backlog-details-card">
              <div className="assessment-backlog-details-card-header">
                <div className="assessment-backlog-details-staff-name-container">
                  User Details
                </div>
              </div>
              <div className="assessment-backlog-user-details-card-body">
                <div className="user-details-card-body-header">
                  <div className="user-details-card-body-header1">S.No</div>
                  <div className="user-details-card-body-header2">Name</div>
                  <div className="user-details-card-body-header3">
                    Email Address
                  </div>
                </div>

                {assessmentDetails?.users?.map((row, index) => {
                  return (
                    <div className="user-details-card-body-body">
                      <div className="user-details-card-body-body1">
                        {index + 1}
                      </div>
                      <div className="user-details-card-body-body2">
                        {row?.user_name}
                      </div>
                      <div className="user-details-card-body-body3">
                        {row?.email}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewAssessmentBacklog;
